<template>
  <v-dialog :value="true" max-width="500">
    <v-card>
      <v-card-title class="headline">Adicionar nota {{ referenceTitle }}</v-card-title>
      <v-card-text class="pt-4">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-autocomplete
            label="Assunto"
            v-model="fields.titleId.value"
            :rules="[...fields.titleId.rules]"
            :items="formatedTitleOptions"
            outlined dense
          ></v-autocomplete>
          <v-select
            label="Status"
            v-model="fields.isActive.value"
            :items="fields.isActive.options"
            outlined dense
          ></v-select>
          <v-textarea
              label="Anotação"
              v-model="fields.note.value"
              :rules="[...fields.note.rules]"
              outlined dense
              rows="4"
            ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="id" outlined color="error" :disabled="saving || deleting" :loading="deleting" text @click="deleteItem()">
          Excluir
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving || deleting" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving || deleting" :loading="saving" text @click="saveItem()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'deleteModal',
  props: {
    item: {
      required: true,
      type: Object
    },
    id: {
      required: true,
      type: String
    },
    reference: {
      required: true,
      type: String
    },
    titleOptions: {
      type: Array
    }
  },
  data: () => ({
    saving: false,
    deleting: false,
    fields: {
      celebrationId: {
        value: ''
      },
      participantId: {
        value: ''
      },
      customerId: {
        value: ''
      },
      titleId: {
        value: '',
        rules: [
          v => !!v || 'O assunto é obrigatório'
        ]
      },
      note: {
        value: '',
        rules: [
          v => !!v || 'O assunto é obrigatório'
        ]
      },
      isActive: {
        value: true,
        options: [
          { value: true, text: 'Ativa' },
          { value: false, text: 'Inativa' }
        ]
      }
    },
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      data.reference = this.reference
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    },
    referenceTitle () {
      switch (this.reference) {
        case 'celebration':
          return 'na Turma'
        case 'participant':
          return 'no Participante'
        default:
          return 'no Cliente'
      }
    },
    formatedTitleOptions () {
      if (this.titleOptions) {
        return this.titleOptions.map(e => {
          return {
            value: e.id,
            text: e.value
          }
        })
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    saveItem () {
      this.saving = true
      const lastUpdate = this.$firebase.firestore.Timestamp.now()

      if (this.id) {
        this.$firestore.collection('notes').doc(this.id).set({ ...this.apiData, lastUpdate })
          .then(() => {
            this.SET_SNACKBAR({ text: 'Nota editada' })
            this.$emit('ok')
            this.saving = false
          })
          .catch(() => {
            this.errorMessage = 'Houve um erro ao processar seu pedido, por favor tente novamente'
            this.saving = false
          })
      } else {
        this.$firestore.collection('notes').add({ ...this.apiData, lastUpdate })
          .then(() => {
            this.SET_SNACKBAR({ text: 'Nota adicionada' })
            this.$emit('ok')
            this.saving = false
          })
          .catch(() => {
            this.errorMessage = 'Houve um erro ao processar seu pedido, por favor tente novamente'
            this.saving = false
          })
      }
    },
    deleteItem () {
      this.deleting = true
      this.$firestore.collection('notes').doc(this.id).get()
        .then(async (snapshot) => {
          await snapshot.ref.delete()
          this.SET_SNACKBAR({ text: 'Nota excluida' })
          this.$emit('ok')
          this.deleting = false
        })
        .catch(() => {
          this.errorMessage = 'Houve um erro ao processar seu pedido, por favor tente novamente'
          this.deleting = false
        })
    }
  },
  created () {
    if (this.id && !this.item) {
      this.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
      this.$emit('canceled')
    }

    for (let key in this.fields) {
      if (key === 'isActive') this.fields[key].value = (this.id) ? !!this.item[key] : true
      else if (this.item && this.item[key]) this.fields[key].value = this.item[key]
      else this.fields[key].value = ''
    }
  }
}
</script>
